import { createElement, Fragment, type ReactNode } from 'react';

/** "{0} … {1}" with React parts in between (a name in bold) – one fragment, no list keys. */
export function fill(text: string, ...parts: ReactNode[]): ReactNode {
  const pieces = text.split(/(\{\d\})/).map((piece) => {
    const m = /^\{(\d)\}$/.exec(piece);
    return m ? parts[Number(m[1])] : piece;
  });
  return createElement(Fragment, null, ...pieces);
}
